import { webVitalsObserver } from '../../observer/web-vitals-observer';

// exported to allow testing
export const webVitalsMetricCustomTimeout = async (
	ttciEnabled: boolean,
	timeout: number,
): Promise<{
	[key: string]: any;
}> => {
	// wait for webVitalsObserver.ttciDetermined if ttciEnabled is true
	await (ttciEnabled ? webVitalsObserver.ttciDetermined : Promise.resolve());
	// wait up to $timeout ms longer for web-vitals until returning
	const timeoutWindow = new Promise((resolve) => setTimeout(resolve, timeout));
	await Promise.race([timeoutWindow, webVitalsObserver.webVitalsDetermined]);
	return webVitalsObserver.data;
};
